import React from 'react'
import { BrowserRouter, Route, useHistory, useLocation, useParams } from 'react-router-dom'
import { LocalizationContext, LocalizationContextType } from '../shared/contexts'
import CatalogueProvider from './CatalogueProvider'
import CatalogueLayout from './CatalogueLayout'
import { OrderProvider } from './catalogueTypes'
import { CATEGORY_ROUTE, parseWorkspace } from './catalogueUrls'

interface CataloguePageProps {
  orderProviders: OrderProvider[]
  canManageCategories: boolean
}

const CataloguePage = ({ orderProviders, canManageCategories }: CataloguePageProps) => {
  const { categoryId } = useParams<{ categoryId?: string }>()
  const location = useLocation()
  const history = useHistory()

  return (
    <CatalogueProvider
      categoryId={categoryId ? Number(categoryId) : null}
      workspace={parseWorkspace(location.search)}
      orderProviders={orderProviders}
      canManageCategories={canManageCategories}
      navigate={history.push}
    >
      <CatalogueLayout />
    </CatalogueProvider>
  )
}

interface ProductCatalogueAppProps {
  localization_context: LocalizationContextType
  orderProviders: OrderProvider[]
  canManageCategories: boolean
}

const ProductCatalogueApp = ({ localization_context, orderProviders, canManageCategories }: ProductCatalogueAppProps) => (
  <LocalizationContext.Provider value={localization_context}>
    <BrowserRouter>
      <Route path={CATEGORY_ROUTE}>
        <CataloguePage orderProviders={orderProviders} canManageCategories={canManageCategories} />
      </Route>
    </BrowserRouter>
  </LocalizationContext.Provider>
)

export default ProductCatalogueApp
